import { type ReactNode, type ElementType } from 'react'
import { useInView } from '@/lib/useInView'
import { useReducedMotion } from '@/lib/useReducedMotion'

type Props = {
  as?: ElementType
  children: ReactNode
  className?: string
  delay?: number
}

export function ScrollFade({ as: Tag = 'div', children, className = '', delay = 0 }: Props) {
  const { ref, inView } = useInView<HTMLElement>()
  const reduced = useReducedMotion()
  const baseTransition = reduced ? '' : 'transition-all duration-500 ease-out'
  const visibility = inView || reduced ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
  const style = !reduced && delay > 0 ? { transitionDelay: `${delay}ms` } : undefined
  return (
    <Tag ref={ref} className={`${baseTransition} ${visibility} ${className}`} style={style}>
      {children}
    </Tag>
  )
}
